import jstz from 'jstz'

$(function() {
  if (!$('meta[name="timezone"]').attr('content')) {
    let timezone = jstz.determine()
    $.post('/timezone', { _method: 'put', timezone: timezone.name() })
  }
})
